import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccessDeniedComponent {

}
